<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      :visible.sync="visible"
      width="90%"
      :title="title"
      :close-on-click-modal="false"
      :before-close="() => close()"
      destroy-on-close
      append-to-body
    >
      <Main ref="main" @checkbox-change="(e) => (checkedRow = e)" />
      <span slot="footer">
        <el-button size="small" class="mr-2" @click="close()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-badge :value="checkCount">
          <el-button
            type="primary"
            size="small"
            @click="confirm()"
            :disabled="isEmpty"
          >
            {{ $l('INDEX.btn_confirm') || '确认' }}
          </el-button>
        </el-badge>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
  },
  data() {
    return {
      checkedRow: [],
    }
  },
  watch: {
    visible: {
      handler(val) {
        if (!val) this.checkedRow = []
      },
    },
  },
  computed: {
    isEmpty() {
      return !this.checkedRow || !this.checkedRow.length
    },
    checkCount() {
      if (this.isEmpty) return 0
      return this.checkedRow.length
    },
  },
  methods: {
    async confirm() {
      if (this.isEmpty) return

      const $main = this.$refs.main
      if (!(await $main.validate())) return
      const data = await $main.getTableData()
      this.$emit('confirm', data)
    },
    close() {
      if (this.isEmpty) {
        this.$emit('update:visible', false)
        this.$emit('close')
        return
      }

      this.$confirm('是否要放弃当前数据，关闭弹框？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '保存',
        cancelButtonText: '放弃',
      })
        .then(() => {
          this.confirm()
        })
        .catch(() => {
          this.$emit('update:visible', false)
          this.$emit('close')
        })
    },
  },
}
</script>
